module.exports = __webpack_public_path__ + "static/media/icon_building_star.284d8c2c.svg";